// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PP2daAE_JSkhoQARHp6q{margin-top:24px;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContainer": `PP2daAE_JSkhoQARHp6q`
};
export default ___CSS_LOADER_EXPORT___;
